import { render, staticRenderFns } from "./power-copy.vue?vue&type=template&id=3571a9c5&scoped=true"
import script from "./power-copy.vue?vue&type=script&lang=ts"
export * from "./power-copy.vue?vue&type=script&lang=ts"
import style0 from "./power-copy.vue?vue&type=style&index=0&id=3571a9c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571a9c5",
  null
  
)

export default component.exports